export default "__VITE_ASSET__Za25iwT9__"